import { Injectable } from '@angular/core';
import { DataFilterDisplayService } from '../../../filters';
import { Observable, of } from 'rxjs';
import { SalesOpportunitiesService } from '../../../../../data-services/sales-opportunities.service';
import { map, take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class PipelineSelectorDisplayService implements DataFilterDisplayService {
  constructor(
    protected readonly salesOpportunitiesService: SalesOpportunitiesService,
    private translate: TranslateService,
  ) {}

  getDisplay(value: any[]): Observable<string> {
    const pipelineId = value?.[0];
    const stage = value?.[1];
    if (!pipelineId || !stage) {
      return of('AUTOMATIONS.EDITOR.FILTERS.OPPORTUNITY_DATA.INVALID_PIPELINE_AND_STAGE');
    }
    return this.salesOpportunitiesService.getMulti([pipelineId]).pipe(
      take(1),
      map((pipelines) => {
        const pipeline = pipelines[0];
        let stageName = pipeline.stages.find((s) => s.probability === stage)?.name;
        if (stage === '*') {
          stageName = this.translate.instant('AUTOMATIONS.EDITOR.FILTERS.OPPORTUNITY_DATA.DATA_LABELS.ANY_STAGE');
        }
        return `${pipeline.name} - ${stageName}`;
      }),
    );
  }
}
